// toast/ToastContext.js
import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { SnackbarContainer } from "../shared/components/Snackbar";
import { ActionIconContainer, Icon } from "../shared/components/TableElements";
import { Col } from "react-bootstrap";

const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
  const [toast, setToast] = useState(null); // { type: 'success' | 'error', text: string }

  const showToast = useCallback((type, text) => {
    setToast({ type, text });
  }, []);

  let iconClassName = "";
  let iconColor = "";

  if (toast?.type === "success") {
    iconClassName = "fi fi-rs-check-circle";
    iconColor = "green";
  }

  if (toast?.type === "error") {
    iconClassName = "fi fi-rr-cross-circle";
    iconColor = "red";
  }

  useEffect(() => {
    if (toast) {
      const timeout = setTimeout(() => setToast(null), 4000);
      return () => clearTimeout(timeout); // cleanup on unmount or new toast
    }
  }, [toast]);

  return (
    <ToastContext.Provider value={{ toast, showToast }}>
      {children}
      {toast && (
        // <div
        //   className={`toast-container position-fixed top-0 end-0 p-3`}
        //   style={{ zIndex: 1060 }}
        // >
        //   <div
        //     className={`toast show bg-${
        //       toast.type === "error" ? "danger" : "success"
        //     } text-white`}
        //     role="alert"
        //   >
        //     <div className="toast-body">{toast.text}</div>
        //   </div>
        // </div>
        <SnackbarContainer $success={toast.type === "success"}>
          {/* <Row> */}
          <Col
            sm={1}
            className="d-flex align-items-center justify-content-center p-2"
          >
            <Icon
              className={iconClassName || "fi fi-rs-check-circle"}
              style={{ color: iconColor || "green", fontSize: "24px" }}
            ></Icon>
          </Col>
          <Col
            sm={10}
            className="d-flex align-items-center justify-content-start p-2"
          >
            <p>{toast.text}</p>
          </Col>
          <Col
            sm={1}
            className="d-flex align-items-center justify-content-center p-0"
          >
            <ActionIconContainer onClick={() => setToast(null)}>
              <i className="fi fi-rr-cross-small" />
            </ActionIconContainer>
          </Col>
          {/* </Row> */}
        </SnackbarContainer>
      )}
    </ToastContext.Provider>
  );
};

export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) throw new Error("useToast must be used within a ToastProvider");
  return context;
};
